import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import { ApiError } from '@/api/client'
import { AuthProvider } from '@/auth/AuthContext'
import { ToastProvider } from '@/components/ui/Toast'
import { zbierajBledy } from '@/lib/diagnostyka'
import { App } from './App'
import './index.css'

// Nasłuch zaczyna się przed pierwszym renderem: błąd z ładowania aplikacji
// też ma trafić do zgłoszenia.
zbierajBledy()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Błędów uprawnień i walidacji nie ma sensu ponawiać.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false
        return failureCount < 2
      },
    },
    mutations: { retry: false },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('Nie znaleziono elementu #root.')

createRoot(container).render(
  <StrictMode>
    {/* Flagi przygotowujące na React Router v7 — włączone od razu,
        żeby przyszła aktualizacja nie zmieniła zachowania aplikacji. */}
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
